import { ReactNode } from 'react';
import { useNode, useEditor } from '@craftjs/core';
import { Spacing } from '@/components/editor/settings/SpacingSettings/SpacingSettings';
import { Background } from '@/components/editor/settings/BackgroundSettings/BackgroundSettings';
import { DisplayProps } from '@/components/editor/settings/DisplaySettings/DisplaySettings';
import ContainerSettings from '@/components/editor/settings/ContainerSettings';
import useNormalizeDimentions from '@/components/editor/settings/DimentionSettings/useNormalizeDimentions';
import useNormalizeBackground from '@/components/editor/settings/BackgroundSettings/useNormalizeBackground';
import useNormalizeSpacing from '@/components/editor/settings/SpacingSettings/useNormalizeSpacing';
import useNormalizeDisplay from '@/components/editor/settings/DisplaySettings/useNormalizeDisplay';
import { DimentionProps } from '@/components/editor/settings/DimentionSettings/types';
import useNormalizeBorderRadius from '@/components/editor/settings/BorderRadius/useNormalizeBorderRadius';
import { BorderRadius } from '@/components/editor/settings/BorderRadius/BorderRadiusSettings';
import useResponsiveValues from '../hooks/useResponsiveValues';
import { CssClass } from '@/components/editor/settings/ClassSettings';
import EmptyState from '@/components/EmptyState';

interface Props extends Background, DisplayProps, DimentionProps, Spacing, CssClass, BorderRadius {
  children: ReactNode;
}

const ContainerBlock = (props: Partial<Props>) => {
  const { id, connectors: { connect, drag } } = useNode();

  const responsive = useResponsiveValues();
  const spacing = useNormalizeSpacing(props);
  const dimentions = useNormalizeDimentions(props);
  const background = useNormalizeBackground(props);
  const display = useNormalizeDisplay(props);
  const borderRadius = useNormalizeBorderRadius(props);

  const { isEmpty } = useEditor((_, query) => ({
    isEmpty: !query.node(id).childNodes().length,
  }));

  return (
    <div
      style={{
        ...spacing,
        ...dimentions,
        ...background,
        ...display,
        ...borderRadius,
        boxSizing: 'border-box',
      }}
      ref={(ref: any) => connect(drag(ref))}
      className={`container ${responsive.getValue(props?.cssClass)}`}
      key={`${id}-${responsive.viewport}`}
    >
      {isEmpty ? <EmptyState /> : props?.children}
    </div>
  );
};

ContainerBlock.craft = {
  displayName: 'Contenedor',
  props: {},
  rules: {
    canDrag: () => true,
    canDrop: () => true,
  },
  related: {
    settings: ContainerSettings,
  },
};

export default ContainerBlock;
